import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useHttp from "../hooks/useHttp";
import {
  SHIPPER_PROFILE_URL,
  CARRIER_PROFILE_URL,
} from "../utils/api-ends";


function Wallet() {

  const { sendRequests } = useHttp();
  const userData = useSelector((state) => state.basicInfo.userDetails);
  const [userBalance, setUserBalance] = useState("");

  useEffect(() => {
    
    let url = "";
    //set url depending on user type
    if (userData?.user_type === "shipper") {
      url = SHIPPER_PROFILE_URL;
    } else {
      url = CARRIER_PROFILE_URL;
    }

    // set user values in state
    const response = (data) => {
        setUserBalance(data.data.user_obj.balance)
    };

    // Send request to get profile info
    sendRequests(
      {
        url: url,
        method: "GET",
      },
      response
    );
  }, [userData?.user_type]);


  return (
    <section id="profile-info" className="row justify-content-center">
      <div className="col-md-6">
        <div className="container theme-section" style={{height: '300px', 'paddingTop': '100px'}}>
          <div className="money-info d-flex justify-content-center">
            <span style={{ marginRight: 10 }}>Balance: </span>
            <p>$ {userBalance}</p>
          </div>

          <div className="multiple-btn profile-info-btn">
            <Link to="/withdraw/withdraw-form" data={userData?.id}>
              <i className="fa-solid fa-credit-card"></i>
              Withdraw
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Wallet;
